export default "/institutions/lecard.svg";